const ACCOUNTING_API_BASE_URL = '/accounting/api';
const EXT_PAY_SYS_API_BASE_URL = '/service/ext_pay_sys';
const PAN_KEEPER_API_BASE_URL = '/pankeeper/frontend_api';

export const apiRoutes = {
  pans: (userId: number) =>
    `${ACCOUNTING_API_BASE_URL}/v1/users/${userId}/payments/pans`,
  deletePan: () => `${EXT_PAY_SYS_API_BASE_URL}/bank_card/delete`,
  savePan: () => `${EXT_PAY_SYS_API_BASE_URL}/bank_card/save_pan`,
  putCvv: () => `${PAN_KEEPER_API_BASE_URL}/put_cvv_to_cache/`,
  updateExpDate: () => `${PAN_KEEPER_API_BASE_URL}/update_exp_date/`
};
